














































import { defineComponent } from '@nuxtjs/composition-api';

import Loader from '@/components/ui/loader.vue';
import BiuraBreadcrumbs from '~/components/biura/components/biura-breadcrumbs.vue';
import BiuraShowcase from '~/components/biura/components/biura-showcase.vue';
import BiuraSwiper from '~/components/biura/components/biura-swiper.vue';
import useBiuraSzczegolyService from '~/components/biura/services/useBiuraSzczegolyService';
import Map from '~/components/map/map.vue';
import Modal from '~/components/ui/modal.vue';

export default defineComponent({
  components: {
    BiuraBreadcrumbs,
    BiuraShowcase,
    Modal,
    Map,
    BiuraSwiper,
    Loader,
  },
  middleware: ['biura/routeAuth'],
  setup() {
    return {
      ...useBiuraSzczegolyService(),
    };
  },
  head() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.metaTags as any;
  },
  jsonld() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.jsonLd as any;
  },
});
